import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import {
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB_LARGE,
} from 'helpers/BreakpointHelper';
import { getNetworkBranding } from 'helpers/ContentHelper';
import style from './GeoBlock.css';

const message = 'Fox Nation is not currently available in your location.';
const header = 'Geographic Restriction';

const GeoBlock = (props = {}) => {
  const { breakpoint, branding } = props;
  const notFoundPage = _.get(window, 'ExternalConfig.notFoundPage', {});
  const logo = _.get(notFoundPage, 'logo', null);
  const colors = _.get(notFoundPage, 'color', []);
  const imageDesktop = _.get(notFoundPage, 'background.desktop', null);
  const imageMobile = _.get(notFoundPage, 'background.mobile.portrait', null);
  const currentBranding = branding || getNetworkBranding();
  const wrapper = classNames([style.screen, style[currentBranding]]);
  const images = {
    [SITE_PLATFORM_WEB_LARGE]: imageDesktop,
    [SITE_PLATFORM_WEB]: imageDesktop,
    [SITE_PLATFORM_TABLET]: imageMobile,
    [SITE_PLATFORM_MOBILE]: imageMobile,
  };
  const image = _.get(images, breakpoint, null);
  const isColorBackground = colors && colors.length > 0;
  const isImageBackground = !isColorBackground && image;

  const renderCharacter = () => {
    if (isColorBackground || (isImageBackground && logo)) {
      const character = logo || image;
      return (
        <div className={classNames([style.character, logo && style.logo])}>
          <img src={character} alt="Background character" />
        </div>
      );
    }
    return null;
  };

  const renderBackground = () => {
    if (isColorBackground) {
      const gradientBG =
        colors.length === 2 ? `radial-gradient(circle at 50% 0, ${colors.join(', ')})` : null;
      const flatBG = colors.length === 1 ? colors[0] : null;
      if (!gradientBG && !flatBG) return null;

      const background = flatBG || gradientBG;
      return <div className={style.background} style={{ background }} />;
    }
    if (isImageBackground) {
      const backgroundStyle = { backgroundImage: `url(${image})` };
      return <div className={style.background} style={backgroundStyle} />;
    }
    return null;
  };

  return (
    <div className={wrapper}>
      {renderBackground()}
      <div className={style.info}>
        {renderCharacter()}
        <div className={style.innerBackground} />
        <div className={style.header}>{header}</div>
        <div className={style.message}>{message}</div>
      </div>
    </div>
  );
};

GeoBlock.defaultProps = {
  breakpoint: SITE_PLATFORM_WEB,
  branding: null,
};

GeoBlock.propTypes = {
  breakpoint: PropTypes.string,
  branding: PropTypes.string,
};

export default GeoBlock;
